import { useEventListener, useResizeObserver } from '@vueuse/core'

interface ScrollCueReturn {
  isScrollCue: Ref<boolean>
}

export const useScrollCue = (key: string): ScrollCueReturn => {
  const target = useTemplateRef<HTMLElement>(key)
  const isScrollCue = ref<boolean>(false)

  const setScrollCue = (): void => {
    const element = target.value

    isScrollCue.value = element
      ? element.scrollHeight - element.scrollTop - element.clientHeight > 1
      : false
  }

  useResizeObserver(target, setScrollCue)
  useEventListener(target, 'scroll', setScrollCue, { passive: true })

  return {
    isScrollCue,
  }
}
